import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ROUTES } from './constants/routes';
import { AuthProvider } from './context/AuthContext';
import { UIProvider } from './context/UIContext';
import AppLayout from './components/layout/AppLayout';
import { ThemeProvider } from './context/ThemeContext';
import ProtectedRoute from './components/auth/ProtectedRoute';
import LoginPage from './pages/LoginPage';
import MfaPage from './pages/MfaPage';
import SearchPage from './pages/SearchPage';
import CustomerDetailPage from './pages/CustomerDetailPage';
import BenefitUpdatePage from './pages/BenefitUpdatePage';
import UserManagementPage from './pages/UserManagementPage';
import BenefitHistoryReportPage from './pages/BenefitHistoryReportPage';
import BenefitAuditReportPage from './pages/BenefitAuditReportPage';
import PaymentFileConfigPage from './pages/PaymentFileConfigPage';
import CalculatorConfigPage from './pages/CalculatorConfigPage';
import ErrorPage from './pages/ErrorPage';

const ROUTER_BASENAME = import.meta.env.PROD ? '/assist/app' : '/';

function App() {
  return (
    <ThemeProvider>
      <UIProvider>
        <AuthProvider>
          {/*todo: figure out how to make work locally correctly*/}

        <BrowserRouter basename={ROUTER_BASENAME}>
            <Routes>
              {/* Public auth routes - use their own AuthPageLayout */}
              <Route path={ROUTES.LOGIN} element={<LoginPage />} />
              <Route path={ROUTES.MFA} element={<MfaPage />} />
              <Route path={ROUTES.ERROR} element={<ErrorPage />} />

              {/* Protected routes - wrapped in AppLayout */}
              <Route path={ROUTES.SEARCH} element={<ProtectedRoute><AppLayout><SearchPage /></AppLayout></ProtectedRoute>} />
              <Route path={`${ROUTES.CUSTOMER}/:accountId`} element={<ProtectedRoute><AppLayout><CustomerDetailPage /></AppLayout></ProtectedRoute>} />
              <Route path={ROUTES.BENEFIT_UPDATE} element={<ProtectedRoute><AppLayout><BenefitUpdatePage /></AppLayout></ProtectedRoute>} />
              <Route path={ROUTES.ADMIN_USERS} element={<ProtectedRoute><AppLayout><UserManagementPage /></AppLayout></ProtectedRoute>} />
              <Route path={ROUTES.ADMIN_BENEFIT_HISTORY} element={<ProtectedRoute><AppLayout><BenefitHistoryReportPage /></AppLayout></ProtectedRoute>} />
              <Route path={ROUTES.ADMIN_AUDIT} element={<ProtectedRoute><AppLayout><BenefitAuditReportPage /></AppLayout></ProtectedRoute>} />
              <Route path={ROUTES.ADMIN_PAYMENT_FILE} element={<ProtectedRoute><AppLayout><PaymentFileConfigPage /></AppLayout></ProtectedRoute>} />
              <Route path={ROUTES.ADMIN_CALCULATOR} element={<ProtectedRoute><AppLayout><CalculatorConfigPage /></AppLayout></ProtectedRoute>} />

              {/* Default redirect */}
              <Route path="/" element={<Navigate to={ROUTES.LOGIN} replace />} />
              {/*Page not found:*/}
              <Route path="*" element={<ProtectedRoute><AppLayout><p className={"text-center"}>Page Not Found</p></AppLayout></ProtectedRoute>} />
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </UIProvider>
    </ThemeProvider>
  );
}

export default App;